/**
 * SideCartManager
 * Matches TypeScript SideCartManager.ts exactly
 * Singleton pattern for managing side cart state
 */
// @ts-nocheck
export class SideCartManager {
  static instance = null;

  static getInstance() {
    if (!SideCartManager.instance) {
      SideCartManager.instance = new SideCartManager();
    }
    return SideCartManager.instance;
  }

  constructor() {
    if (SideCartManager.instance) {
      return SideCartManager.instance;
    }

    this._status = 'closed'; // SideCartStatus.CLOSED
    this.statusChangeCallbacks = [];

    // Make SideCartManager available globally for add-to-cart-handler.js
    window.SideCartManager = SideCartManager;
  }

  get status() {
    return this._status;
  }

  set status(value) {
    if (this._status !== value) {
      this._status = value;
      // Notify all subscribers
      this.statusChangeCallbacks.forEach(callback => {
        try {
          callback(value);
        } catch (e) {
          console.error('Error in status change callback:', e);
        }
      });
    }
  }

  /**
   * Subscribe to status changes
   * @param {Function} callback - Function to call when status changes
   * @returns {Function} Unsubscribe function
   */
  subscribe(callback) {
    this.statusChangeCallbacks.push(callback);
    // Return unsubscribe function
    return () => {
      const index = this.statusChangeCallbacks.indexOf(callback);
      if (index > -1) {
        this.statusChangeCallbacks.splice(index, 1);
      }
    };
  }

  setStatus(status) {
    this.status = status;

    if (status === 'opened') {
      // Track cart open if CartManager exists
      if (window.CartManager && typeof window.CartManager.getInstance === 'function') {
        try {
          window.CartManager.getInstance().trackOpen();
        } catch (e) {
          // Silently fail if CartManager doesn't exist
        }
      }
    }
  }

  open() {
    this.setStatus('opened');
  }

  close() {
    this.setStatus('closed');
  }

  peek(delay = 1500) {
    this.open();
    window.setTimeout(() => {
      this.close();
    }, delay);
  }

  toggle() {
    this.setStatus(this.status === 'opened' ? 'closed' : 'opened');
  }

  getStatus() {
    return this.status;
  }
}

// Export for module usage
export default SideCartManager;

